import { useMemo } from "react"

import { useProductPositionProductInformationByShareLinkQuery } from "entities/product-positions/graphql/queries.generated"
import { getProductType } from "entities/products/lib/getProductType"
import { useCachedProduct } from "entities/products/model/store/useCachedProduct"
import { useExternalDimensioningRestore } from "entities/products/model/useExternalDimensioningRestore"
import { useProductObjLoad } from "entities/products/model/useProductObjLoad"
import { useSharedProjectContext } from "pages/project-page/shared-project-page/context/SharedProjectContext"

import { useProductPositionTableRowPayload } from "../../../contexts/ProductPositionTableRowPayloadContext"
import { ProductPositionTableProductPositionRowProps } from "../ProductPositionTableProductPositionRow"
import { ProductPositionTableSharedProductPositionRowConnectorProps } from "../ProductPositionTableSharedProductPositionRowConnector"

export function useProductPositionTableSharedProductPositionRowModel(
  props: ProductPositionTableSharedProductPositionRowConnectorProps
): ProductPositionTableProductPositionRowProps {
  const { item } = props
  const { pendingProjectChildren } = useProductPositionTableRowPayload()
  useProductObjLoad(item.variantKey)
  const cachedProduct = useCachedProduct(item.variantKey)
  const { projectShareID } = useSharedProjectContext()

  const { data, loading: isLoading } =
    useProductPositionProductInformationByShareLinkQuery({
      variables: { id: item.id, projectShareID }
    })
  const productInformation = data?.productPositionProductInformationByShareLink

  useExternalDimensioningRestore({
    externalDimensioningResult: item.dimensioning
  })

  const isPending = pendingProjectChildren?.includes(item.id)

  const enhancedPayload = useMemo(
    () => ({
      productType: getProductType(item.variantKey),
      title: cachedProduct?.title,
      isTitleLoading: cachedProduct === undefined,
      isValid: !!productInformation,
      isLoadingValidity: isLoading,
      productInformation,
      isPending: !!isPending
    }),
    [productInformation, isLoading, cachedProduct, isPending]
  )

  return {
    ...props,
    ...enhancedPayload
  }
}
